import React, { useState } from 'react';
import { Button, Modal, Tooltip, Typography, message } from 'antd';
import { BellOutlined, CheckCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import usePushNotifications from '../hooks/usePushNotifications';

const { Paragraph } = Typography;

function isPushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window;
}

// Botão de ativação/gestão de notificações push, pensado pro header do Layout.
// Prop `compact` (usada em mobile) esconde o texto e deixa só o ícone.
// Prop `basePath` seleciona os endpoints (`/push` organizador, `/push/player` jogador).
// Prop `contextText` customiza a descrição no modal.
const PushNotificationButton = ({ compact = false, basePath = '/push', contextText }) => {
  const { status, subscribed, loading, subscribe, unsubscribe } = usePushNotifications({ basePath });
  const [modalOpen, setModalOpen] = useState(false);

  if (!isPushSupported()) return null;

  const handleActivate = async () => {
    const result = await subscribe();
    if (result.ok) {
      message.success('Notificações ativadas!');
    } else {
      message.error(result.message || 'Não foi possível ativar as notificações');
    }
  };

  const handleDeactivate = async () => {
    const result = await unsubscribe();
    if (result.ok) {
      message.info('Notificações desativadas');
      setModalOpen(false);
    } else {
      message.error(result.message || 'Erro ao desativar notificações');
    }
  };

  // Permissão negada no navegador — não dá pra reverter via JS, só orientar o usuário.
  if (status === 'denied') {
    return (
      <Tooltip title="Notificações bloqueadas no navegador. Para reativar, abra as configurações do site (ícone de cadeado na barra de endereço) e permita notificações.">
        <Button type="text" icon={<QuestionCircleOutlined />} disabled style={{ opacity: 0.6 }}>
          {!compact && 'Notificações bloqueadas'}
        </Button>
      </Tooltip>
    );
  }

  if (subscribed) {
    return (
      <>
        <Tooltip title={compact ? 'Notificações ativas' : ''}>
          <Button
            type="text"
            icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}
            onClick={() => setModalOpen(true)}
          >
            {!compact && 'Notificações ativas'}
          </Button>
        </Tooltip>
        <Modal
          title="Notificações push"
          open={modalOpen}
          onCancel={() => setModalOpen(false)}
          footer={[
            <Button key="deactivate" danger onClick={handleDeactivate} loading={loading}>
              Desativar
            </Button>,
          ]}
        >
          <Paragraph>
            {contextText || 'Este dispositivo está recebendo notificações push do FuteZap (cobranças geradas, confirmações de jogadores, etc).'}
          </Paragraph>
        </Modal>
      </>
    );
  }

  return (
    <Tooltip title={compact ? 'Ativar notificações' : ''}>
      <Button type="text" icon={<BellOutlined />} onClick={handleActivate} loading={loading}>
        {!compact && 'Ativar notificações'}
      </Button>
    </Tooltip>
  );
};

export default PushNotificationButton;
